(function () {
  if (typeof window.jQuery === 'undefined') {
    var script = document.createElement('script');
    script.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
    script.type = 'text/javascript';
    script.onload = function () {
     jQuery(document).ready(function () {
      var toggleBtn = jQuery('.sort-header');
      var sortList = jQuery('.custom-sort-list');
      var closeBtn = jQuery('.sort-close');
    
      jQuery(document).on('click', '.sort-header', function () {
        jQuery(this).toggleClass('active');
        var container = jQuery(this).closest('.custom-sort-container');
        var sortList = container.find('.custom-sort-list');
        var closeBtn = container.find('.sort-close');
      
        sortList.stop(true, true).slideToggle(200);
        closeBtn.toggle();
      });
    
      jQuery(document).on('click', '.sort-close', function () {
        var container = jQuery(this).closest('.custom-sort-container');
        var sortList = container.find('.custom-sort-list');
        var toggleBtn = container.find('.sort-header');
        
        toggleBtn.removeClass('active');
        sortList.stop(true, true).slideUp(200);
        closeBtn.hide();
      });
    
      jQuery(document).on('click', '.custom-sort-list-items li', function () {
        var sortValue = jQuery(this).data('value');
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortValue);
        window.location.href = url.toString();
      });
    
      jQuery(document).on('click', function (e) {
        if (!jQuery(e.target).closest('.custom-sort-container').length) {
          toggleBtn.removeClass('active');
          sortList.stop(true, true).slideUp(200);
          closeBtn.hide();
        }
      });
    });
    };
    document.head.appendChild(script);
  } else {
  }
})();

// Mobile filter drawer handlers (delegated to survive AJAX content replacement)
// Drawer uses batch-apply: checkboxes don't fire AJAX individually,
// filters submit as one request when the drawer closes.

// Fix duplicate IDs: the drawer and desktop sidebar both render the same filter
// snippet, creating two checkboxes with the same id (e.g. "tag-aluminum").
// Desktop labels with for="tag-aluminum" would target the DRAWER's checkbox
// (first in DOM) instead of their own. Removing drawer IDs fixes this.
(function fixDrawerDuplicateIds() {
  var drawer = document.getElementById('filterDrawer');
  if (!drawer) return;
  drawer.querySelectorAll('input[type="checkbox"][id]').forEach(function (input) {
    input.removeAttribute('id');
  });
  drawer.querySelectorAll('label[for]').forEach(function (label) {
    label.removeAttribute('for');
  });
})();

// Capture-phase listener suppresses drawer checkbox input events so theme.js
// onFormSubmit doesn't fire AJAX per checkbox. Only active while drawer is open.
document.addEventListener('input', function (e) {
  var drawer = document.getElementById('filterDrawer');
  if (drawer && drawer.classList.contains('open') && e.target.closest('#filterDrawer') && e.target.type === 'checkbox') {
    e.stopImmediatePropagation();
  }
}, true);
function applyDrawerFilters() {
  var drawer = document.getElementById('filterDrawer');
  if (!drawer) return;

  var form = drawer.querySelector('.filter-form');
  if (!form) return;

  var searchParams = new URLSearchParams(new FormData(form));
  theme.CollectionAjaxFilter(searchParams);
}

function updateDrawerUI() {
  var drawer = document.getElementById('filterDrawer');
  if (!drawer) return;

  var checked = drawer.querySelectorAll('.filter-form input[type="checkbox"]:checked');
  var count = checked.length;

  // Toggle Clear All visibility
  var clearBtn = drawer.querySelector('#clearFilter');
  if (clearBtn) {
    clearBtn.style.display = count > 0 ? '' : 'none';
  }

  // Update Apply button count
  var countSpan = drawer.querySelector('.total_count');
  if (countSpan) {
    countSpan.textContent = count > 0 ? ' (' + count + ')' : '';
  }

  // Update drawer header count
  var header = drawer.querySelector('.drawer-header > span');
  if (header) {
    var title = header.textContent.replace(/\s*\(\d+\)/, '');
    header.textContent = count > 0 ? title + ' (' + count + ')' : title;
  }
}

function hideDrawerOverlays() {
  var drawer = document.getElementById('filterDrawer');
  if (!drawer) return;
  // Hide the sticky apply bar so its position:fixed child doesn't overlay the page
  var stickyBar = drawer.querySelector('.btn-fltr-sticky');
  if (stickyBar) stickyBar.style.display = 'none';
}

// Listen for checkbox changes inside the drawer — toggle visual state + update counts
document.addEventListener('change', function (e) {
  if (e.target.closest('#filterDrawer') && e.target.type === 'checkbox') {
    // Toggle tag--active class for visual feedback (swatches, styled checkboxes)
    var li = e.target.closest('li.tag');
    if (li) {
      li.classList.toggle('tag--active', e.target.checked);
    }
    updateDrawerUI();
  }
});

document.addEventListener('click', function (e) {
  var drawer = document.querySelector('#filterDrawer');
  if (!drawer) return;

  if (e.target.closest('#openFilters')) {
    drawer.classList.add('open');
    document.body.classList.add('drawer-open');
    updateDrawerUI();
  } else if (e.target.closest('#closeFilters') || e.target.closest('#btnFilterApply')) {
    if (e.target.closest('#btnFilterApply')) e.preventDefault();
    drawer.classList.remove('open');
    document.body.classList.remove('drawer-open');
    hideDrawerOverlays();
    applyDrawerFilters();
  } else if (e.target.closest('#clearFilter')) {
    // Close drawer — theme.js onClearAllClick handles the actual AJAX clearing
    drawer.classList.remove('open');
    document.body.classList.remove('drawer-open');
    hideDrawerOverlays();
  }
});
function initializeFlickity(){try{let e=document.querySelector(".upsell-carousel");e?(attachVariantChangeListeners(),attachAjaxAddToCartListeners(),new Flickity(e,{cellAlign:"left",wrapAround:!1,prevNextButtons:!1})):console.log("Element .upsell-carousel not found.")}catch(t){console.log("Error initializing Flickity: ",t)}}function attachVariantChangeListeners(){try{document.querySelectorAll(".upsell-item-slide .variant-input input[type='radio']").forEach(function(e){e.addEventListener("change",handleVariantChange)}),document.querySelectorAll(".upsell-item-slide .upsell-variant-wrapper select").forEach(function(e){e.addEventListener("change",handleVariantChange)})}catch(e){console.log("Error attaching variant change listeners: ",e)}}function handleVariantChange(e){try{let t=e.target,r=getSelectedVariantColor(t),n=getSelectedVariantSize(t),a=r||n;r&&n&&(a=`${r} / ${n}`),updateVariantSelection(t,a)}catch(l){return null}}function getSelectedVariantColor(e){try{let t=e.closest(".upsell_item").querySelector(".variant-input input[type='radio']:checked");return t?t.value:null}catch(r){return null}}function getSelectedVariantSize(e){try{let t=e.closest(".upsell_item").querySelector(".upsell-variant-wrapper select");return t?t.value:null}catch(r){return null}}function updateVariantSelection(e,t){try{let r=e.closest(".upsell_item"),n=JSON.parse(r.querySelector(".upsell-item-slide form").getAttribute("data-product-json"));n.forEach(function(e){if(e.title===t){r.querySelector(".product-single__variants").value=e.id,r.querySelector(".product-single__variants").dispatchEvent(new Event("change")),r.querySelector(".price").textContent=theme.Currency.formatMoney(e.price,theme.settings.moneyFormat),r.querySelector(".single_img img").src=e.featured_image.src;let n=r.querySelector(".form-buttons .upsell-button");e.available?(n.textContent="ADD",n.removeAttribute("disabled")):(n.textContent="SOLD OUT",n.setAttribute("disabled",!0))}})}catch(a){return null}}function attachAjaxAddToCartListeners(){try{let e=document.querySelectorAll(".upsell-add-to-card");e.forEach(function(e){new theme.AjaxProduct(e,"[data-add-to-cart]",{scopedEventId:"ProductScreen-"})})}catch(t){return null}}document.addEventListener("DOMContentLoaded",function(){let e=document.querySelectorAll(".site--has-mega-menu"),t;if(0===e.length){console.log("No elements found with the class .site--has-mega-menu");return}function r(r){t&&clearTimeout(t),e.forEach(e=>{e&&e.classList.remove("active-mega-menu")}),r.currentTarget&&r.currentTarget.classList.add("active-mega-menu")}function n(r){r.currentTarget&&(t=setTimeout(()=>{e.forEach(e=>{e&&e.classList.remove("active-mega-menu")})},100))}e.forEach(e=>{e&&(e.addEventListener("mouseenter",r),e.addEventListener("mouseleave",n))});var a=document.querySelector(".description-tab .collapsible-content__inner"),l=document.getElementById("read-more-btn");a&&(a.offsetWidth>300&&a.classList.add("max-width-300"),a.scrollHeight>a.clientHeight&&a.classList.add("show-more"),l.addEventListener("click",function(){a.style.maxHeight=a.scrollHeight+"px",a.classList.remove("show-more"),l.style.display="none"}));try{initializeFlickity()}catch(i){console.log("Error during DOMContentLoaded event: ",i)}});
function processLists() {
    const swatchesList = document.querySelectorAll(".mpg-swatch-circle.mpg-swatch__nav");
    if (swatchesList.length === 0) {
        return false;
    }
    swatchesList.forEach((list) => {
        if (list.dataset.processed) return;
        list.dataset.processed = "true";

        const items = list.querySelectorAll("span");
        const maxVisible = 5;

        if (items.length > maxVisible) {
            const hiddenCount = items.length - maxVisible;
            list.setAttribute("data-more", hiddenCount);
        }
    });

    return true;
}

function checkForLists() {
    if (processLists()) {
        clearInterval(checkInterval);
    }
}

const checkInterval = setInterval(checkForLists, 100);
setTimeout(function(){
  clearInterval(checkInterval);
},2000)


